import { Component, Input } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

import { MyBetsBet, MyBetsBetSlip, MyBetsListContext } from '../../../my-bets-base/models/my-bets-viewmodels';

@Component({
    selector: 'ms-my-bets-single-bet-card',
    templateUrl: 'my-bets-single-bet-card.html',
})
export class MyBetsSingleBetCardComponent {
    @Input() betslip: MyBetsBetSlip;
    @Input() myBetsListContext: MyBetsListContext;

    constructor(public sitecore: Sitecore) {}

    get bet(): MyBetsBet {
        return this.betslip.bets[0];
    }

    get isCashoutMessageVisible(): boolean {
        return this.betslip.isRecoveringAfterEditBet;
    }
}
